import { render, staticRenderFns } from "./NumberCard.vue?vue&type=template&id=5a1bd86d&scoped=true&"
import script from "./NumberCard.vue?vue&type=script&lang=js&"
export * from "./NumberCard.vue?vue&type=script&lang=js&"
import style0 from "./NumberCard.vue?vue&type=style&index=0&id=5a1bd86d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1bd86d",
  null
  
)

export default component.exports